import { createAsyncThunk } from '@reduxjs/toolkit';

import type { FormStepId } from 'shared/config/formStepId';

import { formReadyForSendingSelector, selectStepsFields, defaultStepperConfigSelector } from 'entities/creditForm';
import { accountSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataThunk, type TSendCustomerDataThunkState } from 'features/SendCustomerData';

import { getStepsFieldsForUpdate } from './getStepsFieldsForUpdate';
import { recalculateSteps } from './stepper';

type TUpdateUserDataThunkArgs = {
  submittingStepId?: ValuesOf<typeof FormStepId>;
};

export const updateUserDataThunk = createAsyncThunk<
  boolean,
  TUpdateUserDataThunkArgs | void,
  { state: TSendCustomerDataThunkState }
>('updateUserData/updateUserDataThunk', async (args, { dispatch, getState }) => {
  const user = accountSelector(getState());

  if (!user) {
    return true;
  }

  const { stepsWithMultiStepsOrder: steps } = recalculateSteps(defaultStepperConfigSelector(getState()));
  const isReady = formReadyForSendingSelector(getState());
  const forms = defaultStepperConfigSelector(getState());
  const submittingStepId = args?.submittingStepId;

  const filledSteps = getStepsFieldsForUpdate({
    steps,
    forms,
    submittingStepId,
    isFormReady: isReady,
  });

  return dispatch(sendCustomerDataThunk(selectStepsFields(filledSteps)(getState()))).unwrap();
});
